import React, { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'
import styles from './MobileMenu.module.css'

const navigationItems = [
  { id: 'home', label: 'Home' },
  { id: 'about', label: 'About' },
  { id: 'services', label: 'Services' },
  { id: 'projects', label: 'Projects' }
]

const MobileMenu = ({ isOpen, onClose }) => {
  const [activeSection, setActiveSection] = useState('home')
  const location = useLocation()

  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden'
    } else {
      document.body.style.overflow = 'unset'
    }

    return () => {
      document.body.style.overflow = 'unset'
    }
  }, [isOpen])

  useEffect(() => {
    if (location.pathname !== '/') return

    const handleScroll = () => {
      const sections = navigationItems.map(item => ({
        id: item.id,
        element: document.getElementById(item.id)
      })).filter(section => section.element)

      // Find the section closest to the top of the viewport
      let closest = null
      let closestDistance = Infinity

      for (const section of sections) {
        const rect = section.element.getBoundingClientRect()
        const distance = Math.abs(rect.top - 100)

        if (distance < closestDistance) {
          closestDistance = distance
          closest = section.id
        }
      }

      if (closest) {
        setActiveSection(closest)
      }
    }

    window.addEventListener('scroll', handleScroll)
    handleScroll()

    return () => window.removeEventListener('scroll', handleScroll)
  }, [location])

  const handleClick = (e, sectionId) => {
    e.preventDefault()
    onClose()

    if (location.pathname !== '/') {
      window.location.href = `/#${sectionId}`
      return
    }

    setTimeout(() => {
      // For HOME, scroll to top
      if (sectionId === 'home') {
        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        })
        return
      }

      const element = document.getElementById(sectionId)
      if (element) {
        const headerOffset = 80
        const elementPosition = element.getBoundingClientRect().top
        const offsetPosition = elementPosition + window.pageYOffset - headerOffset

        window.scrollTo({
          top: offsetPosition,
          behavior: 'smooth'
        })
      }
    }, 100)
  }

  if (!isOpen) return null

  return (
    <>
      <div className={styles.overlay} onClick={onClose} />
      <div className={`${styles.mobileMenu} ${styles.open}`}>
        <button
          className={styles.closeButton}
          onClick={onClose}
          aria-label="Close menu"
        >
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <line x1="18" y1="6" x2="6" y2="18"></line>
            <line x1="6" y1="6" x2="18" y2="18"></line>
          </svg>
        </button>

        <a
          href="https://calendly.com/inonbaguio/30min"
          target="_blank"
          rel="noopener noreferrer"
          className={styles.ctaButton}
          onClick={onClose}
        >
          <span>Book a Consultation</span>
        </a>

        <nav className={styles.nav}>
          <ul className={styles.navList}>
            {navigationItems.map(item => (
              <li key={item.id} className={styles.navItem}>
                <a
                  href={`#${item.id}`}
                  className={`${styles.navLink} ${
                    location.pathname === '/' && activeSection === item.id ? styles.active : ''
                  }`}
                  onClick={(e) => handleClick(e, item.id)}
                >
                  {item.label}
                </a>
              </li>
            ))}
          </ul>
        </nav>

        <div className={styles.socialLinks}>
          <a
            href="https://github.com/inonbaguio"
            target="_blank"
            rel="noopener noreferrer"
            className={styles.socialLink}
            onClick={onClose}
          >
            GitHub
          </a>
          <a
            href="https://linkedin.com/in/inonbaguio"
            target="_blank"
            rel="noopener noreferrer"
            className={styles.socialLink}
            onClick={onClose}
          >
            LinkedIn
          </a>
          <a
            href="mailto:inonbaguio@gmail.com"
            className={styles.socialLink}
            onClick={onClose}
          >
            Email
          </a>
        </div>
      </div>
    </>
  )
}

export default MobileMenu